import Design1 from './design-1';

import PropTypes from 'prop-types';
import {useContext, useEffect} from "react";
import fitty from "fitty"
import classNames from "classnames";

import './index.css';
import Design2 from "./design-2";
import Block from "../block";
import {WebsiteContext} from "../../index";

SiteNavigationBlock.propTypes = {
    items: PropTypes.array,
    settings: PropTypes.object,
};

SiteNavigationBlock.defaultProps = {};

export function handleBackgroundColour(value, position) {
    if (Array.isArray(value)) {
        return value[position]
    } else {
        return value
    }
}

export const hasStoreActions = () => {
    const context = useContext(WebsiteContext);
    return !!(context.website?.store?.accountManagementEnabled || context.website?.store?.hasShoppingCart || context.website?.store?.canSearch)
}

export function AccountButton(props) {
    const context = useContext(WebsiteContext);
    const initials = context.customerSession?.isAuthenticated
        ? context.customerSession?.initials?.trim()?.slice(0, 2)
        : null;

    return (
        <a href="/my-account/" aria-label="My account" className={classNames(
            props.className,
            "flex items-center justify-center",
            context.builder ? "pointer-events-none" : null,
        )}>
            {initials ? (
                <span className={"reset-font flex h-7 w-7 items-center justify-center rounded-full border border-current"} style={{borderWidth: '1.5px'}}>
                    <span className={"text-[12px] font-semibold uppercase leading-none"}>
                    {initials}
                    </span>
                </span>
            ) : (
                <span className={"flex h-7 w-7 items-center justify-center"}>
                    <svg xmlns="http://www.w3.org/2000/svg" className={"h-7 w-7"} viewBox="0 0 28 28" aria-hidden="true"><path fill="currentColor" d="M13.9987857,28 C21.6682237,28 28,21.6590004 28,14 C28,6.32991987 21.6571219,0 13.9876838,0 C6.33181095,0 0,6.32991987 0,14 C0,21.6590004 6.34292441,28 13.9987857,28 Z M13.9983255,26.0000116 C7.3366468,26.0000116 2.00556251,20.6590462 2.00556251,13.9999992 C2.00556251,7.34089047 7.32477862,2.00001157 13.9864697,2.00001157 C20.6480866,2.00001157 26.0055625,7.34089047 26.0055625,13.9999992 C26.0055625,20.6590462 20.6599425,26.0000116 13.9983255,26.0000116 Z M23.0342184,22.9413796 L22.9862259,22.7166625 C22.1343874,20.726708 18.7298086,18.6715242 13.9987857,18.6715242 C9.28128167,18.6715242 5.87427443,20.726708 5.01371628,22.7055597 L4.96574688,22.9413796 C7.51489049,25.2880132 11.4122195,26.5804544 13.9987857,26.5804544 C16.5989402,26.5804544 20.4628595,25.2991161 23.0342184,22.9413796 Z M13.9987857,16.4382321 C16.6290078,16.4604378 18.6666667,14.2230979 18.6666667,11.3164411 C18.6666667,8.58111524 16.6129332,6.3006361 13.9987857,6.3006361 C11.3870205,6.3006361 9.31977978,8.58111524 9.33326707,11.3164411 C9.34444678,14.2230979 11.3821403,16.4160264 13.9987857,16.4382321 Z"/></svg>
                </span>
            )}
        </a>
    )
}

export function StoreActions() {
    const context = useContext(WebsiteContext);
    return (
        <>
            {context.website?.store?.canSearch ? (
                <div className={"w-4 h-4"}>
                    <svg width="16" height="16">
                        <path
                            d="M6 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM0 6a6 6 0 1 1 10.89 3.477l4.817 4.816a1 1 0 0 1-1.414 1.414l-4.816-4.816A6 6 0 0 1 0 6z"
                            fill="currentColor" fillRule="evenodd"/>
                    </svg>
                </div>
            ) : null}
            {context.website?.store?.hasShoppingCart &&
                <div className={"flex justify-end"}>
                    <button className={"cart badge"} data-badge={"0"} aria-label="View your cart">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none"
                             viewBox="0 0 24 24"
                             stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                  d="M3 3h2l.4 2M7 13h10l4-8h3.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
                        </svg>
                    </button>
                </div>
            }
            {context.website?.store?.accountManagementEnabled && <AccountButton className={""}/>}
        </>
    )
}

export function Header(props) {
    return (
        <Block actions={props.actions} hideInlineAddBlockButton={true} as={"header"} id={'navigation'}
               className={classNames(props.settings?.design !== undefined || props.settings?.design !== null ? `navigation-block-${props.settings?.design ?? 0}` : null, props.className)
               }>
            {props.children}
        </Block>
    )
}

export default function SiteNavigationBlock(props) {
    const width = props.settings?.image?.width || 1;
    const height = props.settings?.image?.height || 1;
    const logoAspectRatio = width / height;

    useEffect(() => {
        const siteNavigation = document.getElementById('block_navigation');
        const updateHeaderHeight = () => {
            const headerHeight = siteNavigation.getBoundingClientRect().height;
            document.documentElement.style.setProperty('--site-nav-height', `${headerHeight}px`);
        };

        updateHeaderHeight(); // Initial calculation

        const resizeObserver = new ResizeObserver(updateHeaderHeight);
        resizeObserver.observe(siteNavigation);

        return () => {
            resizeObserver.unobserve(siteNavigation);
        };

    }, []);

    useEffect(() => {
        // If no logo is present, fits the website name into the logo area
        fitty("header .fit-text", {
            minSize: 16,
            maxSize: 32,
            multiLine: true,
            observeMutations: {attributes: true, subtree: true, childList: true, characterData: true}
        });
    }, [])

    useEffect(() => {
        fitty("header .fit-text", {
            minSize: 16,
            maxSize: 32,
            multiLine: true,
            observeMutations: {attributes: true, subtree: true, childList: true, characterData: true}
        });
    }, [props.settings])

    switch (props.settings?.design) {
        case 0 :
            return (<Design1 {...props} logoAspectRatio={logoAspectRatio}/>);
        case 1 :
            return (<Design2 {...props} logoAspectRatio={logoAspectRatio}/>);
        default:
            return (<Design1 {...props} logoAspectRatio={logoAspectRatio}/>);
    }
};
